var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_3379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3018 14.9214C33.8735 14.9214 33.5249 15.2699 33.5249 15.6983C33.5249 16.1266 33.8735 16.4751 34.3018 16.4751C34.7302 16.4751 35.0787 16.1266 35.0787 15.6983C35.0787 15.2699 34.7302 14.9214 34.3018 14.9214Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 18.1128C21.2024 18.1128 18.1128 21.2024 18.1128 25C18.1128 28.7977 21.2024 31.8874 25 31.8874C28.7977 31.8874 31.8874 28.7977 31.8874 25.0001C31.8874 21.2025 28.7977 18.1128 25 18.1128Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2277 9H17.7723C12.9352 9 9 12.9353 9 17.7724V32.2277C9 37.0648 12.9352 41 17.7723 41H32.2277C37.0648 41 41 37.0648 41 32.2277V17.7724C41 12.9353 37.0648 9 32.2277 9ZM25 33.777C20.1603 33.777 16.2231 29.8397 16.2231 25C16.2231 20.1603 20.1604 16.2231 25 16.2231C29.8396 16.2231 33.777 20.1604 33.777 25C33.777 29.8396 29.8396 33.777 25 33.777ZM34.3019 18.3647C32.8316 18.3647 31.6353 17.1685 31.6353 15.6981C31.6353 14.2277 32.8316 13.0314 34.3019 13.0314C35.7723 13.0314 36.9686 14.2277 36.9686 15.6981C36.9686 17.1684 35.7723 18.3647 34.3019 18.3647Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_3379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.505f10e55895f0aee36cd962a6cd79aa.svg";
export { ForwardRef as ReactComponent };